// extracted by mini-css-extract-plugin
var _1 = "webpack-pages-CitationImports-ImportFromFile-ImportFromFile-module__learnMoreLink";
export { _1 as "learnMoreLink" }
